"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = () => styles_1.createStyles({
    root: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '6px 5px 0 5px',
        borderColor: 'currentColor transparent transparent transparent',
        marginLeft: '1.5em'
    }
});
//# sourceMappingURL=styles.js.map